/* Environment settings */
/* DEV and DEV_API are injected at build time from the `flags` block in
   build.config.js, keyed on BUILD_ENV. Edit the values there, not here.
   ENV is per-file (which HTML variant this pair is wired into), not per
   environment, so it stays hardcoded. */
const DEV = false,                   // for test in "dev" mode (for CTA URL)
    DEV_API = false,           // for using in "dev" Tapptic API to retrieve data (credits, rates, etc.)
    ENV = "DESKTOP";                      // APP-MOBILE || DESKTOP
